import { Question } from "./QuestionTypes"

export const questions: Question[][] = [
	[
		{
			challenge: "What is this instrument called?",
			content: "glockenspiel.jpg",
			category: "music",
			answer: "Glockenspiel",
			reveal: "glockenspiel.mp4",
		},
		{
			challenge: "Which of these is NOT a virtual reality hardware product?",
			choices: [
				{ option: "Oculus Rift" },
				{ option: "Odyssey" },
				{ option: "Second Life", correct: true },
				{ option: "Vive" },
			],
			category: "games",
		},
		{
			challenge: "What fruit is this?",
			content: "guava.jpg",
			answer: "Guava",
			category: "life",
			citation: "https://en.wikipedia.org/wiki/Guava",
		},
		{
			challenge: "Name this person",
			category: "film",
			content: "joe-exotic.jpg",
			answer: "Joe Exotic/Tiger King/Joseph Maldonado-Passage",
		},
		{
			challenge: "Which two U.S. states do not observe Daylight Savings Time?",
			answer: ["Arizona", "Hawaii"],
			category: "world",
			citation: "https://en.wikisource.org/wiki/Congressional_Research_Service_Report_RS22284_Daylight_Saving_Time",
		},
		{
			challenge: "What holiday largely overshadows Halloween in Mexico?",
			reveal: "day-of-the-dead.jpg",
			answer: "Day of the Dead (Día de Muertos)",
			category: "world",
			citation: "https://en.wikipedia.org/wiki/Day_of_the_Dead",
		},
		{
			challenge:
				'In what country was the first recorded account of children using the phrase "trick or treat" on Halloween?',
			answer: "Canada (Foothills County, Alberta)",
			citation: "https://www.cbc.ca/news/canada/calgary/albertans-invent-saying-trick-or-treat-1.3829669",
			reveal: "trick-or-treat.webp",
			category: "halloween",
		},
		{
			challenge: "What country's flag is this?",
			category: "world",
			content: "afghanistan.svg",
			answer: "Afghanistan",
			reveal: "afghanistan-map.svg",
		},
		{
			challenge:
				"According to a 2018 study by the US Federal Reserve, what did consumers most often claim to be their preferred method of payment?",
			choices: [
				{ option: "Cash", data: 22 },
				{ option: "Credit", data: 29 },
				{ option: "Debit", data: 42, correct: true },
				{ option: "Other", data: 7 },
			],
			percentage: true,
			category: "economics",
			citation:
				"https://www.frbsf.org/cash/publications/fed-notes/2019/june/2019-findings-from-the-diary-of-consumer-payment-choice/",
		},
		{
			challenge: "What country is being promoted in this tourism campaign?",
			category: "world",
			answer: "Kazakhstan (inspired by Borat)",
			content: "very-nice.mp4",
			reveal: "very-nice2.mp4",
			fullscreen: true,
		},
		{
			challenge: "What is the name of the new Borat movie?  Bonus: name the actor who plays Borat",
			category: "film",
			content: "borat.jpg",
			reveal: "borat2.jpg",
			answer: ["Borat: Subsequent Moviefilm", "Sacha Baron Cohen"],
		},
		{
			challenge: "Name this person",
			content: "pewdiepie.jpg",
			category: "world",
			answer: "Felix Kjellberg aka Pewdiepie, YouTuber with 107M subscribers",
			citation: "https://www.youtube.com/user/pewdiepie",
		},
		{
			challenge: "What is the value of Euler's number (e) to at least 2 decimal places?",
			category: "philosophy",
			answer: 2.72,
			reveal: "euler.png",
		},
		{
			challenge: "Which Canadian province/territory has the fewest senators per capita?",
			answer: "British Columbia",
			category: "world",
			reveal: "senators.png",
			citation: "https://sencanada.ca/en/senators-list/",
		},
		{
			challenge: "What does CSV stand for in a typcal .csv file?",
			category: "tech",
			choices: [
				{ option: "Comma Separated Values", correct: true },
				{ option: "Command Sequence Values" },
				{ option: "Command Separated Values" },
				{ option: "Computer Sequence Values" },
			],
			reveal: "csv.png",
		},
	],
	[
		{
			challenge: "Solve this rebus",
			content: "raising-hell.jpg",
			answer: "Raising hell / hell-raiser",
			category: "puzzle",
		},
		{
			challenge: "Name the song",
			category: "music",
			answer: "Get Lucky",
			content: "songs/get-lucky.mp4",
			reveal: "songs/get-lucky.jpg",
		},
		{
			challenge: "What entity does this badge represent?",
			answer: "Canadian Armed Forces (CAF)",
			category: "local",
			content: "canadian-forces.svg",
			citation: "https://forces.ca/en/",
		},
		{
			challenge: "What is the collective noun for a group of flamingos?",
			answer: "A flamboyance",
			content: "flamingo.jpg",
			category: "life",
			citation: "https://www.theatlantic.com/photo/2020/05/photos-a-flamboyance-of-flamingos/611848/",
		},
		{
			challenge: 'Who wrote "In Flanders Fields"?',
			answer: "John McCrae",
			category: "literature",
			reveal: "john-mccrae.jpg",
		},
		{
			challenge: "Which character from the Charlie Brown series writes letters to the Great Pumpkin?",
			answer: "Linus",
			category: "halloween",
			reveal: "great-pumpkin.jpg",
		},
		{
			challenge: "What was Dr. Frankeinstein's first name?",
			answer: "Victor",
			category: "halloween",
			reveal: "frankenstein.jpg",
		},
		{
			challenge: "How many eyes do bees have? (not two!)",
			reveal: "bee-eyes.jpg",
			answer: 5,
			category: "life",
			citation: "https://en.wikipedia.org/wiki/Bee",
		},
		{
			challenge: "What was in the Space Shuttle's large external fuel tank?",
			answer: ["Oxygen", "Hydrogen"],
			category: "tech",
			content: "shuttle.jpg",
			reveal: "shuttle-tank.jpg",
		},
		{
			challenge: "What is the collective noun for a group of bats?",
			answer: "A cauldron, cloud, colony, or hanger",
			category: "halloween",
			citation: "https://www.animalsandenglish.com/collective-nouns-etc79.html",
			reveal: "bats.png",
		},
		{
			challenge: "What kind of tree is this?",
			category: "life",
			content: "oak.jpg",
			answer: "Oak (Angel Oak)",
		},
		{
			challenge: "What is the tiny piece at the end of a shoelace called?",
			answer: "Aglet",
			content: "aglet.jpg",
			category: "industry",
			citation: "https://en.wikipedia.org/wiki/Aglet",
		},
		{
			challenge: "Which clothing company is NOT Canadian?",
			choices: [
				{ option: "Arc'teryx" },
				{ option: "Lululemon" },
				{ option: "The North Face", correct: true },
				{ option: "Roots" },
			],
			reveal: "northface.svg",
			category: "industry",
		},
		{
			challenge: "Which of the following is a valid URL?",
			category: "tech",
			choices: [
				{ option: "404 Not Found" },
				{ option: "ftp://joe:Password1@[::1]:21/trivia/answers.txt", correct: true },
				{ option: "GET / HTTP/1.1" },
				{ option: "google.ca" },
			],
			citation: "https://tools.ietf.org/html/rfc2732",
		},
		{
			challenge: "Solve this rebus",
			content: "square-root.jpg",
			answer: "Square root",
			category: "puzzle",
		},
	],
	[
		{
			challenge: "Which of these car companies is Korean?",
			category: "industry",
			content: "carlogos.svg",
			answer: "Hyundai",
			reveal: "hyundai.svg",
			citation: "https://en.wikipedia.org/wiki/Hyundai_Motor_Company",
		},
		{
			challenge: "Which country has the most recorded cases of COVID-19?",
			category: "health",
			choices: [
				{ option: "Brazil", data: 5_496_402 },
				{ option: "India", data: 8_088_046 },
				{ option: "Russia", data: 1_581_693 },
				{ option: "United States", data: 9_212_567, correct: true },
			],
			citation: "https://www.worldometers.info/coronavirus/countries-where-coronavirus-has-spread/",
		},
		{
			challenge: "Who is the most recent Lightweight UFC Champion?",
			answer: "Khabib Nurmagomedov (Хабиб Абдулманапович Нурмагомедов)",
			category: "games",
			reveal: "khabib.png",
		},
		{
			challenge: "According to family fued, nobody wants to see pictures of your...",
			choices: [{ option: "Body", correct: true }, { option: "Kids" }, { option: "Pet" }, { option: "Vacation" }],
			category: "games",
			citation: "https://mstiescott.neocities.org/feud16_8.html",
		},
		{
			challenge: "Name something you love doing when you're all alone",
			choices: [
				{ option: "Going nude" },
				{ option: "Reading", correct: true },
				{ option: "Sleeping" },
				{ option: "Taking a bath" },
			],
			category: "games",
			citation: "https://mstiescott.neocities.org/feud16_8.html",
		},
		{
			challenge: "What is this?",
			content: "playstation-5.jpg",
			category: "tech",
			answer: "Playstation 5",
			reveal: "playstation-5-logo.jpg",
		},
		{
			challenge: "What TV show is this theme song for?",
			answer: "The Office",
			reveal: "the-office.jpg",
			content: "the-office.mp4",
			category: "film",
		},
		{
			challenge: "What movie is this?",
			answer: "Starship Tropers",
			content: "starship-troopers.mp4",
			reveal: "starship-troopers.jpg",
			category: "film",
			fullscreen: true,
		},
		{
			challenge: "What movie is this?",
			answer: "The Mask of Zorro",
			content: "mask-of-zorro.mp4",
			reveal: "mask-of-zorro.jpg",
			category: "film",
			fullscreen: true,
		},
		{
			challenge:
				"What were the approximate total expenses of the Government of Canada in the last audited fiscal year (2018-19)?",
			category: "economics",
			choices: [
				{ option: "$350 million" },
				{ option: "$35 billion" },
				{ option: "$350 billion", correct: true },
				{ option: "$3.5 trillion" },
			],
			citation:
				"https://www.canada.ca/en/department-finance/services/publications/annual-financial-report/2019/report.html#_Toc17893652",
		},
		{
			challenge: "Name the movie",
			category: "film",
			content: "oblivion2.mp4",
			reveal: "film/oblivion.jpg",
			answer: "Oblivion (2013)",
			fullscreen: true,
		},
		{
			challenge: "What is the name of this bone?",
			category: "health",
			content: "coccyx.png",
			answer: "Coccyx",
			citation: "https://en.wikipedia.org/wiki/Coccyx",
		},
		{
			challenge: "What 1973 movie scared people out of using Ouiji boards?",
			answer: "The Exorcist",
			reveal: "the-exorcist.mp4",
			category: "halloween",
		},
		{
			challenge: "Order these famous Greek philosophers from oldest to youngest",
			category: "philosophy",
			choices: [
				{ option: "Aristotle, Plato, Socrates" },
				{ option: "Aristotle, Socrates, Plato" },
				{ option: "Plato, Aristotle, Socrates" },
				{ option: "Socrates, Plato, Aristotle", correct: true },
			],
			reveal: "greek-philosophy.jpg",
			citation:
				"https://www.dummies.com/education/philosophy/socrates-plato-and-aristotle-the-big-three-in-greek-philosophy/",
		},
		{
			challenge: "What were typical jack-o'-lanterns originally made from?",
			answer: "Turnips, potatoes, rutabagas, mangel wurzels (aka mangel beet, field beet, fodder beet)",
			category: "halloween",
			reveal: "irish-jackolantern.jpg",
			citation: "https://www.history.com/news/history-of-the-jack-o-lantern-irish-origins",
		},
	],
]

// TODO audio support
// Identify YouTube channels eg Try Guys, Jeffrey Star, Sofia Nygard, Vsauce
// Russian Avengers ripoff movie scene
// What was Kirkegaard's philosophy
// What is a deepfake
// Whicho f these is a deepfake?
// Which scene (deepfake video game, etc.) is real life?
// How long for rabies symptoms
// Afghanistan language Pashto
// Pakistan language Urdu
// How many editions of Canadian currency are there?
// Where is Pondicherry
// Deadliest diseases in history
// New bridge Tuktouktuk
// Epic Rap Battles, identify character EG Gorbachev
// Russian plane company Sukhoi, MIG
// mortality rate, wars per country, diseseas
// Jewish folk party song with the side kicks
// $XIC $XMD $XIU
// How wide is the solar system?
// What year was the UN established?
// What is the most subscribed YouTube channel?
// What is Zoom?
// What year did Netflix start?
// How much memory is on a bluray disc?  (dual layer etc?)
// What is Dolby Atmos?
// What's the difference between sofa and chesterfield?
// What does NATO stand for?
// When/how did Stalin die?
// What is the DSM?
// Chemical equation?  H2SO4 + Cl = HSO4 + HCl kind of thing
// How many square kilometres of provincial park are there?
//  - Canadian question, national parks in Canada?  Jurisdiction differences?
// What kind of tree is this? (picture)
// What's the difference between red and black ants?  Species names, are they the same, etc?
// What celestial body has the largest mountain?  Earth/Venus/Mars/Moon?  Should be moon right?What criteria makes Pluto not a planet anymore?
// Daoism vs taoism?
// Korea what do the flag symbols represent (water fire earth wind)
// Scene from The Last Airbender
// Scene from Modern Family
// What industries does China lead?  Biggest oil and gas company?  Phone company?
// Something 5G.  "What is 5G"?
// Canadian companies.  Arc'teryx, Lululemon, Blackberry, Shopify
// What is Shopify?
// Physics: object is dropped from a height of 1 km in a vacuum tube on earth.  how long to hit bottom?
// How many people has Coronavirus infected?
// Who wrote Alice in Wonderland?
// What car logo is (mercury)
// Which fashion brand is founded/owned (careful on wodering) by a woman?  Versace, Dolce & Gabbana, Gucci, Burberry
// What is this logo?  Balenciaga?
// What is this logo?  Bentley, Alfa Romeo, Maserati, Mercury
// Identify this theme song?  Shows.  The Office.
// Who is this?  Carol Baskin
// Who is this?  Epstein
// Which of these is NOT a streaming service?  Hulu Spotify Netflix
// Who is the current UFC <weightclass> champion?
// What song is this?  lyrics "bright and early" "no expression" "filling up their glasses" sorrow.  Do the commercial.
// What percentage fo the internet is YouTube?  Netflix?
// What is the flower of BC?  Dogwood.
// Fendi logo
// How old is International Women's Day?
// How many Canadians have died at war?
// How many km of railroad are there in Canada?
// Beyonce's family names.  Blue Ivy?
// What is the difference between DSLR and mirrorless?
// Logo: Flickr
// Nursing: when did Canada or the WHO recommend masks?
// In 2010 Lady Gaga wore the meat dress
// What year did Blurred Lines come out
// PS I Love You movie clip.
// movie ideas
// akira
// american psycho
// cowboys and aliens
// dead poets society
// edge of tomorrow
// face off
// gattaco
// hot fuzz
// metaballs
// minority report
// obliviion
// rain man
// singing in the rain
// tangled
// the good the bad and the ugly
// thor ragnarok
// the wolf of wallstreet
// world war z
